module.exports = __webpack_public_path__ + "f6349e69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/price.svg
// module id = 1876
// module chunks = 15 18 19 20 37